import { useSelector } from 'react-redux';
import { selectUser } from '../redux/selectors';

export const useSession = () => {
  const user = useSelector(selectUser);
  const isLoggedIn = user ? user.id !== '' : false;
  return { isLoggedIn, user };
};
